<template>
  <select class="form-control taxon-select" @change="onChange">
    <option value="">{{ blankText }}</option>
    <optgroup v-for="group in taxonGroups" :key="group.label" :label="group.label">
      <option
        v-for="taxon in group.taxons"
        :key="taxon.permalink"
        :value="taxon.permalink"
        :selected="isSelected(taxon)"
      >
        {{ taxon.label }}
      </option>
    </optgroup>
  </select>
</template>

<script>
  export default {
    props: {
      taxonGroups: {
        type: Array,
        required: true
      },
      selectedTaxon: {
        type: Object,
        default: null
      },
      blankText: {
        type: String,
        default: '-- Change Product Category --'
      }
    },
    methods: {
      onChange(event) {
        this.$emit('change', event.target.value)
      },
      isSelected(taxon) {
        return this.selectedTaxon && this.selectedTaxon.name === taxon.label
      }
    }
  }
</script>

<style>
  .form-inline .taxon-select.form-control {
    width: 100%;
  }
</style>
